import * as types from './types'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialUIState = {
	activeWorkLogOrg: null,
	activeTab: null,
	activeTabEmployer: 'timingWork.active',
	selectedCarouselDate: null,
	employeeSelectedCarouselDate: null,
	disabledDates: [],
	employeeDisabledDates: [],
	selectedEmployee: null,
	searchQuery: '',
	newlyAddedDates: [],
	errorMessage: '',
	modals: {
		isDownloadModalOpen: false,
		isDeleteModalOpen: false,
		isUpdateCompaniesModalOpen: false,
	},
	datePickers: {
		isDatePickerOpen: false,
		isSearchDatePickerOpen: false,
		isEmployerSearchDatePickerOpen: false,
		selectedDate: null,
		searchSelectedDate: null,
		employerSearchSelectedDate: null,
	},
	isCompanyAllowed: false,
	companyAllowedLoading: false,
}

const initialEmployerState = {
	activeEmployeeList: { ...data },
	firedEmployeeList: { ...data },
	employeeDates: { ...data },
	workByDate: { ...data },
}

const initialState = {
	workLog: data,
	employer: initialEmployerState,
	ui: initialUIState,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.GET_WORKLOG_DATA:
			return { ...state, workLog: { ...data, loading: true } }
		case types.GET_WORKLOG_DATA_DONE:
			return { ...state, workLog: { ...data, data: payload, success: true } }
		case types.GET_WORKLOG_DATA_FAIL:
			return { ...state, workLog: { ...data, failed: true } }

		case types.ADD_WORK_TO_WORKLOG:
			return {
				...state,
				workLog: {
					...state.workLog,
					data: {
						...state.workLog.data,
						content: state.workLog.data?.content?.map((org) => {
							if (org.bin === payload.bin) {
								return {
									...org,
									employees: org.employees.map((employee) => ({
										...employee,
										depts: employee.depts.map((dept) => {
											if (dept.code === payload.deptCode) {
												return {
													...dept,
													works: [...(dept.works || []), payload.work],
												}
											}
											return dept
										}),
									})),
								}
							}
							return org
						}),
					},
				},
			}

		case types.UPDATE_WORK_IN_WORKLOG:
			return {
				...state,
				workLog: {
					...state.workLog,
					data: {
						...state.workLog.data,
						content: state.workLog.data?.content?.map((org) => {
							if (org.bin === payload.bin) {
								return {
									...org,
									employees: org.employees.map((employee) => ({
										...employee,
										depts: employee.depts.map((dept) => {
											if (dept.code === payload.deptCode) {
												return {
													...dept,
													works:
														dept.works?.map((work) =>
															work.externalId === payload.work.externalId ? payload.work : work
														) || [],
												}
											}
											return dept
										}),
									})),
								}
							}
							return org
						}),
					},
				},
			}

		case types.DELETE_WORK_IN_WORKLOG:
			return { ...state, workLog: { ...state.workLog, loading: true } }

		case types.DELETE_WORK_IN_WORKLOG_DONE:
			return {
				...state,
				workLog: {
					...state.workLog,
					loading: false,
					success: true,
					data: {
						...state.workLog.data,
						content: state.workLog.data?.content?.map((org) => {
							if (org.bin === payload.bin) {
								return {
									...org,
									employees: org.employees.map((employee) => ({
										...employee,
										depts: employee.depts.map((dept) => {
											if (dept.code === payload.deptCode) {
												return {
													...dept,
													works: dept.works?.filter((work) => work.externalId !== payload.workId) || [],
												}
											}
											return dept
										}),
									})),
								}
							}
							return org
						}),
					},
				},
			}

		case types.DELETE_WORK_IN_WORKLOG_FAIL:
			return { ...state, workLog: { ...state.workLog, loading: false, failed: true } }

		case types.DELETE_DAY_ACTION:
			return { ...state, workLog: { ...state.workLog, loading: true } }

		case types.DELETE_DAY_ACTION_FAIL:
			return { ...state, workLog: { ...state.workLog, loading: false, failed: true } }

		// UI State Management
		case types.SET_ACTIVE_WORK_LOG_ORG:
			return {
				...state,
				ui: {
					...state.ui,
					activeWorkLogOrg: payload,
				},
			}

		case types.SET_ACTIVE_TAB:
			return {
				...state,
				ui: {
					...state.ui,
					activeTab: payload,
				},
			}

		case types.SET_ACTIVE_TAB_EMPLOYER:
			return {
				...state,
				ui: {
					...state.ui,
					activeTabEmployer: payload,
				},
			}

		case types.SET_SELECTED_CAROUSEL_DATE:
			return {
				...state,
				ui: {
					...state.ui,
					selectedCarouselDate: payload,
				},
			}

		case types.SET_EMPLOYEE_SELECTED_CAROUSEL_DATE:
			return {
				...state,
				ui: {
					...state.ui,
					employeeSelectedCarouselDate: payload,
				},
			}

		case types.SET_DISABLED_DATES:
			return {
				...state,
				ui: {
					...state.ui,
					disabledDates: payload,
				},
			}

		case types.SET_EMPLOYEE_DISABLED_DATES:
			return {
				...state,
				ui: {
					...state.ui,
					employeeDisabledDates: payload,
				},
			}

		case types.SET_SELECTED_EMPLOYEE:
			return {
				...state,
				ui: {
					...state.ui,
					selectedEmployee: payload,
				},
			}

		case types.SET_SEARCH_QUERY:
			return {
				...state,
				ui: {
					...state.ui,
					searchQuery: payload,
				},
			}

		case types.SET_NEWLY_ADDED_DATES:
			return {
				...state,
				ui: {
					...state.ui,
					newlyAddedDates: payload,
				},
			}

		case types.SET_ERROR_MESSAGE:
			return {
				...state,
				ui: {
					...state.ui,
					errorMessage: payload,
				},
			}

		// Modal Management
		case types.SET_MODAL_STATE:
			return {
				...state,
				ui: {
					...state.ui,
					modals: {
						...state.ui.modals,
						[payload.modalName]: payload.isOpen,
					},
				},
			}

		case types.RESET_MODAL_STATES:
			return {
				...state,
				ui: {
					...state.ui,
					modals: {
						...initialUIState.modals,
					},
				},
			}

		// Date Picker Management
		case types.SET_DATE_PICKER_STATE:
			return {
				...state,
				ui: {
					...state.ui,
					datePickers: {
						...state.ui.datePickers,
						[payload.pickerName]: payload.isOpen,
					},
				},
			}

		case types.SET_SELECTED_DATE:
			return {
				...state,
				ui: {
					...state.ui,
					datePickers: {
						...state.ui.datePickers,
						[payload.dateName]: payload.date,
					},
				},
			}

		// Reset State
		case types.RESET_EMPLOYEE_DATA:
			return {
				...state,
				ui: {
					...state.ui,
					selectedEmployee: null,
					employeeDisabledDates: [],
					employeeSelectedCarouselDate: null,
					datePickers: {
						...state.ui.datePickers,
						isEmployerSearchDatePickerOpen: false,
						employerSearchSelectedDate: null,
					},
				},
			}

		case types.RESET_ORG_DATA:
			return {
				...state,
				ui: {
					...state.ui,
					selectedCarouselDate: null,
					activeTab: null,
					disabledDates: [],
					newlyAddedDates: [],
				},
			}

		case types.RESET_WORKLOG_STATE:
			return {
				...initialState,
				// Сохраняем только isLoading, чтобы не ломать состояние загрузки
				isLoading: state.isLoading,
			}

		case types.COMPANY_ALLOWED:
			return {
				...state,
				ui: {
					...state.ui,
					isCompanyAllowed: false,
					companyAllowedLoading: true,
				},
			}

		case types.COMPANY_ALLOWED_DONE:
			return {
				...state,
				ui: {
					...state.ui,
					isCompanyAllowed: Boolean(payload),
					companyAllowedLoading: false,
				},
			}

		case types.COMPANY_ALLOWED_FAIL:
			return {
				...state,
				ui: {
					...state.ui,
					isCompanyAllowed: false,
					companyAllowedLoading: false,
				},
			}

		case types.GET_ACTIVE_EMPLOYEE_LIST:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					activeEmployeeList: { ...data, loading: true },
				},
			}
		case types.GET_ACTIVE_EMPLOYEE_LIST_DONE:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					activeEmployeeList: { ...data, data: payload, success: true },
				},
			}
		case types.GET_ACTIVE_EMPLOYEE_LIST_FAIL:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					activeEmployeeList: { ...data, failed: true },
				},
			}

		case types.GET_FIRED_EMPLOYEE_LIST:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					firedEmployeeList: { ...data, loading: true },
				},
			}
		case types.GET_FIRED_EMPLOYEE_LIST_DONE:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					firedEmployeeList: { ...data, data: payload, success: true },
				},
			}
		case types.GET_FIRED_EMPLOYEE_LIST_FAIL:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					firedEmployeeList: { ...data, failed: true },
				},
			}

		case types.GET_EMPLOYEE_DATES:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					employeeDates: { ...data, loading: true },
				},
			}
		case types.GET_EMPLOYEE_DATES_DONE:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					employeeDates: { ...data, data: payload, success: true },
				},
			}
		case types.GET_EMPLOYEE_DATES_FAIL:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					employeeDates: { ...data, failed: true },
				},
			}

		case types.GET_WORK_BY_DATE:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					workByDate: {
						// сохраняем предыдущие данные, чтобы таблица не мигала
						...((state.employer && state.employer.workByDate) || data),
						loading: true,
						failed: false,
						success: false,
					},
				},
			}
		case types.GET_WORK_BY_DATE_DONE:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					workByDate: { ...data, data: payload, success: true },
				},
			}
		case types.GET_WORK_BY_DATE_FAIL:
			return {
				...state,
				employer: {
					...(state.employer || initialEmployerState),
					workByDate: { ...data, failed: true },
				},
			}

		default:
			return state
	}
}
